import React, { useState } from "react";

import { TextareaChangeEventDetail } from "@ionic/core";

// Import Ionic
import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonItem,
  IonRow,
  IonTextarea,
  useIonLoading,
  useIonToast,
  useIonViewWillEnter,
} from "@ionic/react";

// Import Icons
import { star, starOutline } from "ionicons/icons";

// Import Styles
import classNames from "classnames/bind";
import styles from "./AddReviewModal.module.scss";

// Import Components
import CommonModal from "../UI/CommonModal/CommonModal";
import { useAddProductReviewMutation } from "../../providers/products";
import { ProductReviewPayload } from "@core/types";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const AddReviewModal = (props: any) => {
  const { t } = useTranslation();
  const {  firstName, lastName, id, email, onDismiss } = props;

  const [presentLoading, dismissLoading] = useIonLoading();
  const [presentToast] = useIonToast();

  const [rating, setRating] = useState(0);
  const [description, setDescription] = useState("");

  const { mutate: addProductReviewMutate } = useAddProductReviewMutation({
    onSuccess: () => {
      presentToast({
        message: t("Your comment will be published after moderation"),
        duration: 2000,
        color: "success",
      });
    },
    onError: () => {
      presentToast({
        message: t("An unexpected error occurred"),
        duration: 2000,
        color: "danger",
      });
    },
    onSettled: () => {
      dismissLoading();
      props.onDismiss();
    },
  });

  useIonViewWillEnter(() => {
    setRating(0);
    setDescription("");
  });

  const addComment = () => {
    presentLoading(t("Please wait..."));

    const data: ProductReviewPayload = {
      rating: rating,
      product_id: id,
      review: description,
      reviewer_email: email,
      reviewer: `${firstName} ${lastName}`,
      fullName: `${firstName} ${lastName}`,
    };

    addProductReviewMutate(data);
  };

  const isButtonDisabled = () => {
    return rating === 0 || !description;
  };

  const generateStars = () => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span className={cx("addReviewStarWrapper")} onClick={() => setRating(i)}>
          <IonIcon className={cx("addReviewStar")} color="warning" icon={i > rating ? starOutline : star} key={i} />
        </span>
      );
    }

    return stars;
  };

  return (
    <>
      <CommonModal
        onDismiss={onDismiss}
        title={t("Comment about this product")}
        classNameContent={cx("addReview")}
      >
        <span className={"commonModalSupTitle"}>{t("rating")}</span>
        <IonGrid className="ion-no-padding ion-margin-bottom">
          <IonRow className={cx("addReviewStarsRow", "ion-no-padding")}>
            <IonCol className={cx("addReviewStarsCol", "ion-no-padding")}>{generateStars()}</IonCol>
          </IonRow>
        </IonGrid>
        <span className={"commonModalSupTitle"}>Комментарий</span>
        <form>
          <IonItem className={cx("addReviewDescriptionItem", "ion-no-padding")} lines="none">
            <IonTextarea
              className={cx("addReviewDescription")}
              rows={10}
              value={description}
              placeholder={t("Enter a description")}
              name="desc"
              required
              onIonChange={(e: CustomEvent<TextareaChangeEventDetail>) => setDescription(e.detail.value!)}
            />
          </IonItem>
        </form>
        <IonButton
          className={cx("addReviewButton")}
          expand="block"
          color="primary"
          onClick={() => addComment()}
          disabled={isButtonDisabled()}
        >
          {t("Post Comment")}
        </IonButton>
      </CommonModal>
    </>
  );
};

export default AddReviewModal;
